import { TabDescriptor, CommandeBCI } from '../types';

// Presta BCI : un SEUL onglet "Offre" (pas d'historique/consultation/messagerie/evaluation).
// La case presta BCI se resume a consulter l'offre et l'envoyer a l'acheteur (par email).
export const buildCommandeTabs = (_commande: CommandeBCI): TabDescriptor[] => [
  { key: 'offre', kind: 'offre', label: 'Offre', disabled: false, inactive: false },
];

// Un seul onglet -> index par defaut toujours 0. Signature alignee sur useCommandeTabs.
export const computeDefaultTabIndex = (_descriptors: TabDescriptor[], _commande: CommandeBCI): number => 0;
